import {ProductListBanner, ProductListBannerContext} from "./types";

const FILTER_CONTEXTS: Record<string, ProductListBannerContext> = {
    categories: {filterType: "CATEGORY"},
    producers: {filterType: "PRODUCER"},
    brands: {filterType: "BRAND"},
    licenses: {filterType: "LICENSE"},
    news: {filterType: "NEW"},
    promotions: {filterType: "PROMOTION"},
    sales: {filterType: "SALE"}
};

export function getProductListBannerContext(filter?: string, filterId?: string): ProductListBannerContext | null {
    const context = filter ? FILTER_CONTEXTS[filter] : undefined;

    if (!context) {
        return null;
    }

    return filterId ? {...context, filterId} : context;
}

export function getProductListBannerSetKey(banners: ProductListBanner[]): string {
    return JSON.stringify(banners.map(({id, image, url, order}) => ({id, image, url, order})));
}

export function getProductListBannerUrl(url: string): string {
    return url.startsWith("http") ? url : `${window.location.origin}${url}`;
}
